import "./tree.css";
import * as React from "react";

const nodeHeight = 55;
const enlargedNodeHeight = 90;
const lineWidth = 20;

export function ConnectionNode({ element, children, value, enlarged = false }) {
  const inputSpeed = value === 0 ? 0 : value > 0 ? 1 : -1;
  const height = enlarged ? enlargedNodeHeight : nodeHeight;
  const num = React.Children.count(children);

  const inputAnimation =
    inputSpeed !== 0
      ? "gradient " + Math.round(500 / Math.abs(inputSpeed)) + "s linear infinite" + (inputSpeed > 0 ? "" : " reverse")
      : null;

  return (
    <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", position: "relative" }}>
      {/* line - element */}
      <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <div style={{ width: lineWidth / 2, height: 2, animation: inputAnimation }} className="move" />
        <div style={{ height: height, display: "flex", justifyContent: "center", alignItems: "center" }}>{element}</div>
      </div>

      {/* children */}

      {children && (
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
          {React.Children.map(children, (child, index) => {
            if (!child) {
              return null;
            }

            const [childSpeed, childVerticalSpeed] = calculateSpeeds(children, index);

            return {
              ...child,
              props: {
                ...child.props,
                drawLine: index < num - 1 && num > 1,
                speed: childSpeed,
                verticalSpeed: childVerticalSpeed,
                key: index,
              },
            };
          })}
        </div>
      )}
    </div>
  );
}

export function Node({ element, children, drawLine, value, speed, verticalSpeed = 1, enlarged = false }) {
  const inputSpeed = speed !== undefined ? speed : value === 0 ? 0 : value > 0 ? 1 : -1;
  const height = enlarged ? enlargedNodeHeight : nodeHeight;
  const num = React.Children.count(children);
  const outputSpeed =
    num > 0
      ? roundSpeed(
          value /
            (React.Children.toArray(children).reduce((v, c) => (v + c.props.value ? Math.abs(c.props.value) : 0), 0) /
              children.length),
        )
      : 0;

  const inputAnimation =
    inputSpeed !== 0
      ? "gradient " + Math.round(500 / Math.abs(inputSpeed)) + "s linear infinite" + (inputSpeed > 0 ? "" : " reverse")
      : null;
  const outputAnimation =
    outputSpeed !== 0
      ? "gradient " +
        Math.round(500 / Math.abs(outputSpeed)) +
        "s linear infinite" +
        (outputSpeed > 0 ? "" : " reverse")
      : null;
  const verticalAnimation =
    verticalSpeed !== 0
      ? "gradient-y " +
        Math.round(500 / Math.abs(verticalSpeed)) +
        "s linear infinite" +
        (verticalSpeed > 0 ? "" : " reverse")
      : null;

  return (
    <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", position: "relative" }}>
      {/* vertical line */}
      {drawLine ? (
        <div
          style={{
            width: 2,
            height: "100%",
            position: "absolute",
            marginTop: height / 2,
            animation: verticalAnimation,
          }}
          className="move-y"
        />
      ) : null}

      {/* line - element - line */}
      <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <div style={{ width: lineWidth, height: 2, animation: inputAnimation }} className="move" />
        <div style={{ height: height, display: "flex", justifyContent: "center", alignItems: "center" }}>{element}</div>
        {children && <div style={{ height: 2, width: lineWidth, animation: outputAnimation }} className="move" />}
      </div>

      {/* children */}

      {children && (
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
          {React.Children.map(children, (child, index) => {
            if (!child) {
              return null;
            }

            const [childSpeed, childVerticalSpeed] = calculateSpeeds(children, index);

            return {
              ...child,
              props: {
                ...child.props,
                drawLine: index < num - 1 && num > 1,
                speed: childSpeed,
                verticalSpeed: childVerticalSpeed,
                key: index,
              },
            };
          })}
        </div>
      )}
    </div>
  );
}

function calculateSpeeds(c, index) {
  const children = React.Children.toArray(c);

  if (children.length === 0) {
    return [0, 0];
  }

  var totalAbs = 0;
  var remaining = 0;

  for (var i = 0; i < children.length; ++i) {
    const v = children[i].props.value ? children[i].props.value : 0;
    totalAbs = totalAbs + Math.abs(v);

    if (i > index) {
      remaining = remaining + v;
    }
  }

  const avgLoad = totalAbs / children.length;
  if (children[index] === undefined) return [0, 0];
  const relativeSpeed = children[index].props.value ? children[index].props.value / avgLoad : 0;
  const remainingSpeed = remaining / avgLoad;

  return [roundSpeed(relativeSpeed), roundSpeed(remainingSpeed)];
}

function roundSpeed(v) {
  if (v === 0) {
    return 0;
  }

  const t = Math.round(5 * (v - 0.1)) / 5 + 0.1;

  if (t < 0.4 && t > 0) {
    return 0.4;
  } else if (t > -0.4 && t < 0) {
    return -0.4;
  } else if (t > 2) {
    return 2;
  } else if (t < -2) {
    return -2;
  }

  return t;
}
